import { render, staticRenderFns } from "./FooterOne.vue?vue&type=template&id=9bb2b5b6&"
import script from "./FooterOne.vue?vue&type=script&lang=js&"
export * from "./FooterOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports